export const DEFAULT_PROJECT_TIMEZONE = "America/New_York";

const TIMEZONE_LABELS = {
  "America/New_York": "ET",
  "America/Chicago": "CT",
  "America/Denver": "MT",
  "America/Phoenix": "AZ",
  "America/Los_Angeles": "PT",
  "America/Anchorage": "AKT",
  "Pacific/Honolulu": "HT",
};

export const formatExpectedTiming = (value, timeZone = DEFAULT_PROJECT_TIMEZONE) => {
  if (!value) return "—";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";

  const zone = timeZone || DEFAULT_PROJECT_TIMEZONE;
  const dateText = new Intl.DateTimeFormat("en-US", {
    timeZone: zone,
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(date);
  const timeText = new Intl.DateTimeFormat("en-US", {
    timeZone: zone,
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(date);

  return `${dateText} • ${timeText} ${TIMEZONE_LABELS[zone] || zone}`;
};
